/**
 * Copyright (C) 2022 Viasat, Inc.
 * All rights reserved.
 * The information in this software is subject to change without notice and should not be construed as a commitment by Viasat, Inc.
 *
 * Viasat Proprietary
 * The Proprietary Information provided herein is proprietary to Viasat and
 * must be protected from further distribution and use. Disclosure to others,
 * use or copying without express written authorization of Viasat, is strictly prohibited.
 */
import { AjaxResponse } from 'rxjs/ajax';
import ActionCreator from '../action-creator';
import { TerminalDetails } from '../../shared/entities/terminal';
import { AnnotationPoint } from '../../components/fleet/FullTailView/charts/ChartWrappers/TimelineChartHelperFunctioners';
import { RateKeys } from './reducer';
import { PortalsEnum } from '../../shared/entities/portal';

export interface TerminalHistoryUpdatePayload {
  terminal: TerminalDetails;
  useOtherTerminalOnPlatformDataForUpdate?: boolean;
}

export interface RequestTerminalHistoryOncePayload {
  datapathUuid: string;
  portal: PortalsEnum;
}

export const ActionCreators = {
  RequestTerminalHistoryOnce: new ActionCreator<'RequestTerminalHistoryOnce', RequestTerminalHistoryOncePayload>(
    'RequestTerminalHistoryOnce',
  ),
  CancelRequestTerminalHistory: new ActionCreator<'CancelRequestTerminalHistory', any>('CancelRequestTerminalHistory'),
  ReceivedTerminalHistorySuccess: new ActionCreator<'ReceivedTerminalHistorySuccess', AjaxResponse<any>>(
    'ReceivedTerminalHistorySuccess',
  ),
  ReceivedTerminalHistoryError: new ActionCreator<'ReceivedTerminalHistoryError', any>('ReceivedTerminalHistoryError'),
  ReceivedTerminalHistoryUpdateSuccess: new ActionCreator<
    'ReceivedTerminalHistoryUpdateSuccess',
    TerminalHistoryUpdatePayload
  >('ReceivedTerminalHistoryUpdateSuccess'),
  ReceivedTerminalTrafficError: new ActionCreator<'ReceivedTerminalTrafficError', any>('ReceivedTerminalTrafficError'),
  ClearReceivedTerminalHistoryError: new ActionCreator<'ClearReceivedTerminalHistoryError', any>(
    'ClearReceivedTerminalHistoryError',
  ),
  SetChartsXAxisMinMax: new ActionCreator<'SetChartsXAxisMinMax', { min: number; max: number }>('SetChartsXAxisMinMax'),
  SetAnnotations: new ActionCreator<'SetAnnotations', Partial<AnnotationPoint>[]>('SetAnnotations'),
  SetAllProtocolsModalTimestamp: new ActionCreator<'SetAllProtocolsModalTimestamp', number>(
    'SetAllProtocolsModalTimestamp',
  ),
  SetAllProtocolsModalRateKeys: new ActionCreator<'SetAllProtocolsModalRateKeys', RateKeys>(
    'SetAllProtocolsModalRateKeys',
  ),
  SetAllProtocolsModalUseOtherTerminalHistory: new ActionCreator<
    'SetAllProtocolsModalUseOtherTerminalHistory',
    boolean
  >('SetAllProtocolsModalUseOtherTerminalHistory'),
  SetAllProtocolsModalData: new ActionCreator<
    'SetAllProtocolsModalData',
    {
      allProtocolsModalTimestamp: number | undefined;
      allProtocolsRateType: RateKeys | undefined;
      allProtocolsUseOtherTerminalHistory: boolean | undefined;
    }
  >('SetAllProtocolsModalData'),
};

export type Action = typeof ActionCreators[keyof typeof ActionCreators];

export function getTerminalHistoryOnce(datapathUuid: string, portal = PortalsEnum.UNIFIED_PORTAL) {
  return (dispatch: any) => {
    dispatch(ActionCreators.RequestTerminalHistoryOnce.create({ datapathUuid, portal }));
  };
}

export function cancelTerminalHistory() {
  return (dispatch: any) => {
    dispatch(ActionCreators.CancelRequestTerminalHistory.create());
  };
}

export function setChartsXAxisMinMax(min: number, max: number) {
  return ActionCreators.SetChartsXAxisMinMax.create({ min, max });
}

export function setAnnotations(annotations: Partial<AnnotationPoint>[]) {
  return ActionCreators.SetAnnotations.create(annotations);
}

export function setTheAllProtocolModalData(
  unixTimestamp: number | undefined,
  rateKey: RateKeys | undefined,
  useOtherTermHistory: boolean | undefined,
) {
  return ActionCreators.SetAllProtocolsModalData.create({
    allProtocolsModalTimestamp: unixTimestamp,
    allProtocolsRateType: rateKey,
    allProtocolsUseOtherTerminalHistory: useOtherTermHistory,
  });
}
